import React from 'react';
import Textbox from '../../Textbox/Textbox';
import Dropdown from '../../DropDown/Dropdown';
import Selectionbox from '../../SelectionBox/SelectionBox';
import {SelectionBoxDurations, InterviewTypeList } from '../../../../shared/constants';
import './InterviewDetailsStep2.css';

const InterviewDetailsStep2 = (props) => {
  return(
    <div className="interview-details-step-two">
      <div className="interview-type-place">
        <div className="interviewplace">
          <Textbox
            className="interview-place" 
            id="interviewplace" 
            label="Where will the interview be taking place?"
            placeholder="eg. Lapps Quay, Cork"
            onChange={(e) => props.handleInterviewLocation(e)}
            value={props.interviewLocation}
          >          
          </Textbox>
        </div>
        <div className="inteview-type">
          <label className="interview-type-label">What type of interview will it be?</label>
          <Dropdown 
          list={InterviewTypeList} 
          placeholder="Please Select" 
          className="interview-type-dropdown"
          handleItemChange={props.handleItemChange}
          activeId={props.activeId}
          activeItem={props.activeItem}
          />
        </div>
        <div className="interviewduration">
          <label>Interview Duration</label>
          <Selectionbox
            className="interview-duration-items"
            data={SelectionBoxDurations}
            handleSelect={props.handleInterviewDuration}
            activeElementId={props.activeElementId}
          >
          </Selectionbox>
        </div>
      </div>
      <div className="interview-duration-select">
      </div>
    </div>
  );
}

export default InterviewDetailsStep2;


// WEBPACK FOOTER //
// ./src/components/UI/StepperContent/InterviewDetailsStep2/InterviewDetailsStep2.js